import React, {useEffect, useState} from 'react';
import {Col, Row} from 'reactstrap';
import Select from "react-select";
import {Utils} from "custom";
import {ConsulentAPI} from "api";

const ClientSetting = ({onFilterClients}) => {
    const [consulents, setConsulents] = useState([]);

    const [filterConsulent, setFilterConsulent] = useState(null);
    const [filterUserActive, setFilterUserActive] = useState(null);
    const [filterClassroomActive, setFilterClassroomActive] = useState(null);

    const isAdmin = Utils.getUserData().role === "ADMIN";

    useEffect(() => {
        if (!isAdmin)
            return;

        ConsulentAPI.list().then((resCons) => {
            resCons = resCons.filter((c) => c.active);

            let consulentsArr = [
                {value: -1, label: <small><i>Non Assegnato</i></small>}
            ];

            setConsulents(
                consulentsArr.concat(
                    resCons.map((c) => ({
                        value: c.id,
                        label: c.firstname + " " + c.lastname
                    }))
                )
            );
        }).catch((e) => {
            console.error(e);
        });
    }, [isAdmin]);

    useEffect(() => {
        onFilterClients(filterConsulent, filterUserActive, filterClassroomActive);
    }, [filterConsulent, filterUserActive, filterClassroomActive, onFilterClients]);

    return (
        <React.Fragment>
            <Row className="mb-1">
                {isAdmin ? (
                    <Col xl={4} className="p-1">
                        <Select
                            value={filterConsulent}
                            options={consulents}
                            isClearable
                            placeholder="Filtra consulente"
                            className='me-5 w-100'
                            onChange={(val) => {
                                setFilterConsulent(val !== null ? val : null);
                            }}
                        />
                    </Col>
                ) : null}

                <Col xl={4} className="p-1">
                    <Select
                        value={filterUserActive}
                        options={[
                            {value: true, label: "Utente Attivo"},
                            {value: false, label: "Utente Non Attivo"}
                        ]}
                        isClearable
                        placeholder="Filtra stato utente"
                        className='me-5 w-100'
                        onChange={(val) => {
                            setFilterUserActive(val !== null ? val : null);
                        }}
                    />
                </Col>

                <Col xl={4} className="p-1">
                    <Select
                        value={filterClassroomActive}
                        options={[
                            {value: true, label: "Classe Attiva"},
                            {value: false, label: "Classe Non Attiva"}
                        ]}
                        isClearable
                        placeholder="Filtra stato classe"
                        className='me-5 w-100'
                        onChange={(val) => {
                            setFilterClassroomActive(val !== null ? val : null);
                        }}
                    />
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default ClientSetting;
